import { render, staticRenderFns } from "./singleTextInp.vue?vue&type=template&id=6536b888&scoped=true&"
import script from "./singleTextInp.vue?vue&type=script&lang=js&"
export * from "./singleTextInp.vue?vue&type=script&lang=js&"
import style0 from "./singleTextInp.vue?vue&type=style&index=0&id=6536b888&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6536b888",
  null
  
)

export default component.exports